$(document).ready(function () {

  /* home banner*/
  $(".js-hmbanner").slick({
    autoplay:true,
    slidesToShow: 1,
    arrows: true,
    fade: true,
    dots:true,
			responsive: [
      {
        breakpoint: 769,
        settings: {
          arrows:false,
        }
      }
      ]
  }); 


  /* feature product*/
  $('#f-product-tab').easyResponsiveTabs({
    type:'default',
    activate:function(){}
  });
  $('#f-product-tab .product-list').slick({
      arrows: true,
      dots: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      horizontal: true,
      infinite: true,
      autoplay: false,
      pauseOnHover: false,
      autoplaySpeed: 3000,
      responsive: [
      {
        breakpoint: 1441,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 1201,
        settings: {
          slidesToShow: 3
        }
      },
              {
        breakpoint: 769,
        settings: {
          slidesToShow: 2
        }
      }
      ]
  });
  $("#f-product-tab ul>li").on('click', function () { 		
      $('#f-product-tab .bst-tab .product-list').slick('refresh');   
  });

	//Best sellers slider
	   $('.bestseller-product.product-list').slick({
      arrows: true,
      dots: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      horizontal: true,
      infinite: true,
      autoplay: false,
      pauseOnHover: false,
      autoplaySpeed: 3000,
      responsive: [
      {
        breakpoint: 1441,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 1201,
        settings: {
          slidesToShow: 3
        }
      },
              {
        breakpoint: 769,
        settings: {
          slidesToShow: 2
        }
      }
      ]
  });
	
  // shop by collection slider
  $(".rangecontainer").slick({
		dots: false,
		infinite: true,
		arrows: true,
		slidesToShow: 4,
		slidesToScroll: 1,
		autoplay: false,
		autoplaySpeed: 2500,		
		responsive: [
			{
				breakpoint: 1441,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 1,
				},
			},
			// {
			// 	breakpoint: 1200,
			// 	settings: {
			// 		slidesToShow: 3,
			// 		slidesToScroll: 1,
			// 	},
			// },
			{
				breakpoint: 769,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 577,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					centerMode: true,
					centerPadding: '20px',
				},
			}
		],
	});



  // testimonial slider script
  $(".hm_testimonial_slider").slick({
		dots: false,
		infinite: true,
		arrows: true,
		slidesToShow: 3,
		slidesToScroll: 1,
		autoplay: false,
		autoplaySpeed: 4000,		
		responsive: [
			{
				breakpoint: 1441,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 1201,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 993,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 769,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					centerMode: true,
					centerPadding: '20px',
				},
			}
		],
	});

});

